import { render, staticRenderFns } from "./PanelBox.vue?vue&type=template&id=c9904d74&scoped=true"
import script from "./PanelBox.vue?vue&type=script&lang=js"
export * from "./PanelBox.vue?vue&type=script&lang=js"
import style0 from "./PanelBox.vue?vue&type=style&index=0&id=c9904d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9904d74",
  null
  
)

export default component.exports